//icon
const icon = `${EASYCOMMERCE.assets}admin/img/icons/question-mark.png`;

const TabItem = ({ item, isActive, onClick }) => {
    return (
        <>
            {!isActive ? (
                <div
                    onClick={onClick}
                    className="p-4 flex items-center cursor-pointer w-full"
                >
                    <p className="w-[calc(100%_-_44px)] font-inter text-base leading-[26px] font-normal text-ec-placeholder hover:text-ec-body ">
                        {item.title}
                    </p>
                </div>
            ) : (
                <div className="p-4 flex items-center cursor-pointer w-full bg-ec-accent rounded-lg">
                    <p className="w-[calc(100%_-_44px)] text-base font-inter leading-[26px] font-normal text-ec-primary">
                        {item.title}
                    </p>
                </div>
            )}
        </>
    );
};

export default TabItem;
